/**
 * Object xử lý event global trên toàn bộ hệ thống
 * @author DNThang - 17.03.2020
 */

import Vue from 'vue';
const EventBusGlobal = new Vue();

export default EventBusGlobal;

/**
 * Đối tượng liệt kê các global event đang có
 * Bắt buộc có globalEvent nào đều phải cấu hình vào đây để không bị trùng tên
 * @author DNThang - 17.03.2020
 */
const GlobalEventName = {
	/**
	 * Xử lý đóng tất form
	 */
	closeAllPopup: 'closeAllPopup',
	scrollEvent: 'scrollEvent',
	reloadList: 'reloadList',
	resetPopupCenter: 'resetPopupCenter',
	setWaitingConfirm: 'setWaitingConfirm',
	showHelpViewHistory: 'showHelpViewHistory',
	sortEvent: 'sortEvent',
	closeAllDropdown: 'closeAllDropdown',
	Progress: 'Progress',
	NewInvoice: 'NewInvoice',
	TourGuide: 'TourGuide',
	UploadFile: 'UploadFile',
	RefreshInvoice: 'RefreshInvoice',
	RefreshInvoiceDetail: 'RefreshInvoiceDetail',
	CheckagainInvoiceDetail: 'CheckagainInvoiceDetail',
	RefreshStick: 'RefreshStick',
	ShowFileUpload: 'ShowFileUpload',
	RefreshListStickDetail: 'RefreshListStickDetail',
	RefreshSupplier: 'RefreshSupplier',
	RefreshSupplierNoDownload: 'RefreshSupplierNoDownload',
	OpenUpdatePDF: 'OpenUpdatePDF',
	showEnableUse: 'showEnableUse',
	showCheckLicense: 'showCheckLicense',
	showCheckNps: 'showCheckNps',
	RefreshInvoiceNextPage: 'RefreshInvoiceNextPage',
	UpdatePageValue: 'UpdatePageValue',
	setRememberSortInvoiceList: 'setRememberSortInvoiceList',
	setRememberSortSupplierList: 'setRememberSortSupplierList',
	setRememberSortCompanyList: 'setRememberSortCompanyList',
	setRememberSortInvoiceTrashList: 'setRememberSortInvoiceTrashList',
	EmptyDataDownload: 'EmptyDataDownload',
	EmptyDataDownloadReport: 'EmptyDataDownload',
	EmptyDataDownloadListInv: 'EmptyDataDownloadListInv',
	ReloadOrg: 'ReloadOrg',
	ReloadOrgStructure: 'ReloadOrgStructure',
	BuildTree: 'BuildTree',
	RefreshLicense: 'RefreshLicense',
	ConnectInvoice: 'ConnectInvoice',
	ActiveTab: 'ActiveTab',
	Sync: 'Sync',
	SyncTaxaxion: 'SyncTaxaxion',
	LoadInfoAccept: 'LoadInfoAccept',
	PaymentInvoice: 'PaymentInvoice',
	NotifiLoadPaymentDueDate: 'NotifiLoadPaymentDueDate',
	ShowPaymentWarning: 'ShowPaymentWarning',
	LoadTotalEmailNotRead: 'LoadTotalEmailNotRead',
	UpdateListStick: 'UpdateListStick',
	RefreshInvoicesFirstPage: 'RefreshInvoicesFirstPage',
	RefreshOutInvoicesFirstPage: 'RefreshOutInvoicesFirstPage',
	RefreshInboxFirstPage: 'RefreshInboxFirstPage',
	LoadAgainPdfFromEmail: 'LoadAgainPdfFromEmail',
	RefreshOutInvoice: 'RefreshOutInvoice',
	ShowNotificationTaxaxion: 'ShowNotificationTaxaxion',
	ShowNotificationInvoiceWaiting: 'ShowNotificationInvoiceWaiting',
	NotifiLoadInvoiceFilter: 'NotifiLoadInvoiceFilter',
	ShowInvoiceWaitChecking: 'ShowInvoiceWaitChecking',
	ShowListNotification: 'ShowListNotification',
	SendEmailFeedback: 'SendEmailFeedback',
	ShowNotificationsInbot: 'ShowNotificationsInbot',
	ShowExpiredLicense: 'ShowExpiredLicense',
	LoadSupplierInsert: 'LoadSupplierInsert',
	LoadGridOrgSetting: 'LoadGridOrgSetting',
	ResetCombobox: 'ResetCombobox',
	LoadDataDashboard: 'LoadDataDashboard',
	OptionUploadFile: 'OptionUploadFile',
	LoadHasPdfList: 'LoadHasPdfList',
	ViewDetailForAttach: 'ViewDetailForAttach',
	GetListAutoTransfer: 'GetListAutoTransfer',
	GetAllNoDownloadInvoice: 'GetAllNoDownloadInvoice',
	ConnectNow: 'ConnectNow',
	ConnectAgain: 'ConnectAgain',
	UnConnect: 'UnConnect',
	ShowLostConnectTaxaxion: 'ShowLostConnectTaxaxion',
	RefreshConnectInvoiceTaxaxionInbot: 'RefreshConnectInvoiceTaxaxionInbot',
	RefreshConnectInvoiceTaxaxionOutbot: 'RefreshConnectInvoiceTaxaxionOutbot',
	RefreshConnectInvoiceSupplier: 'RefreshConnectInvoiceSupplier',
	UpdateInoiceSelected: 'UpdateInoiceSelected',
	UpdateChecking: 'UpdateChecking',
	LoadSupplierAcceptTaxAuthority: 'LoadSupplierAcceptTaxAuthority',
	UpdateSearchInvoice: 'UpdateSearchInvoice',
	UploadStatusPdf: 'UploadStatusPdf',
	ChangeStatusViewInvoice: 'ChangeStatusViewInvoice',
	ShowInvoiceRiskBySupplier: 'ShowInvoiceRiskBySupplier',
	AutoFilterInvoiceRisk: 'AutoFilterInvoiceRisk',
	UpdateNote: 'UpdateNote',
	checkNotificationAgain: 'checkNotificationAgain',
	UpdateStatusInvoiceDetail: 'UpdateStatusInvoiceDetail',
	RefreshDeclaration: 'RefreshDeclaration',
	LoadDataList: 'LoadDataList',
	loadStickInvoiceDetail: 'loadStickInvoiceDetail',
	ChangeCurrentCyCode: 'ChangeCurrentCyCode',
	UpdateFileProcessWhenHandEntered: 'UpdateFileProcessWhenHandEntered',
	CheckShowReleaseChatbot: 'CheckShowReleaseChatbot',
	ShowAvaChatbot: 'ShowAvaChatbot',
	HaveNewDataDashBoard: 'HaveNewDataDashBoard',
	EditHandInput: 'EditHandInput',
	UpdateTotalAmountHandInput: 'UpdateTotalAmountHandInput',
	LoadPageSizeGrid: 'LoadPageSizeGrid',
	ReloadDetail: 'ReloadDetail',
	ReloadWidget: 'ReloadWidget',
	OpenSuggestOrRecommend: 'OpenSuggestOrRecommend',
	RefreshListButtonValue: 'RefreshListButtonValue', // Tính toán lại số liệu ở chân trang
	UpdateIsDownload: 'UpdateIsDownload',
	IsImportCompleteSupNoDownload: 'IsImportCompleteSupNoDownload',
	RefreshInvoiceAfterAccept: 'RefreshInvoiceAfterAccept',
	ResizeMsThGroup: 'ResizeMsThGroup',
	SyncInvoiceDetail: 'SyncInvoiceDetail',
	SyncInvoiceDetailOut: 'SyncInvoiceDetailOut',
	ClosePopup: 'ClosePopup', // Sự kiện đóng popup đang mở
	RedirectToSidebar: 'RedirectToSidebar',
	ExpandSidebar: 'ExpandSidebar',
	ShowAVAChat: 'ShowAVAChat',
	AVAExplainInvoice: 'AVAExplainInvoice',
	ReloadCheckBusiness: 'ReloadCheckBusiness',
	ReloadStepInstructionForUse: 'ReloadStepInstructionForUse',
	ShowMisaCommunity: 'ShowMisaCommunity',
	ReloadNavbar: 'ReloadNavbar',
	SendOtpSuccess: 'SendOtpSuccess',
	SearchInvoiceResult: 'SearchInvoiceResult',
	LoginInfo: 'LoginInfo',
	MoveInvoiceDuplicate: 'MoveInvoiceDuplicate',
	MoveDeclarationDuplicate: 'MoveDeclarationDuplicate',
	ConvertIdentificationNumber: 'ConvertIdentificationNumber',
	ConvertIdentificationNumberSuccess: 'ConvertIdentificationNumberSuccess',
	CompareInvoiceQuantityTaxiaxion: 'CompareInvoiceQuantityTaxiaxion',
	CloseAmisSupport: 'CloseAmisSupport',
	UnreadAmisSupport: 'UnreadAmisSupport',
	ShowConnectInvoice: 'ShowConnectInvoice',
	ShowSettingDownloadInvoice: 'ShowSettingDownloadInvoice',
	AnalysisAIResultReceived: 'AnalysisAIResultReceived', // Event nhận kết quả phân tích AI từ SignalR
	SettingConnectTaxaxionWithSyncData: 'SettingConnectTaxaxionWithSyncData',
	AcceptInfoWrongAVAExplain: 'AcceptInfoWrongAVAExplain',
	ReloadCheckingResultAVAExplain: 'ReloadCheckingResultAVAExplain',
	ActionFromTooltip: 'ActionFromTooltip',
	HandleNotificationInvoiceInfoChangeStatus: 'HandleNotificationInvoiceInfoChangeStatus',
	UpdateDeclarationSelected: 'UpdateDeclarationSelected', // Cập nhật danh sách tờ khai đã chọn
	UpdateUserSelected: 'UpdateUserSelected', // Cập nhật danh sách người dùng đã chọn
	CloseBannerHeader: 'CloseBannerHeader',
	ShowMisaIncidentNotification: 'ShowMisaIncidentNotification',
	ReloadUpdateCheckingInvoice: 'ReloadUpdateCheckingInvoice',
	RefreshDashboard: 'RefreshDashboard',
	DashboardLastTimeChanged: 'DashboardLastTimeChanged',
	ShowSidebarTourGuide: 'ShowSidebarTourGuide', // Bật tour guide phân hệ sau khi tour toolbar kết thúc
	ShowNotificationTourGuide: 'ShowNotificationTourGuide' // Bật tour guide notification (livechat) sau khi tour phân hệ kết thúc
};

export { GlobalEventName };
